import {
  Alert,
  Button,
  Center,
  Divider,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  Link,
  Text
} from '@chakra-ui/react';
import { zodResolver } from '@hookform/resolvers/zod';
import { useCallback, useState } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import { Link as ReactRouterLink } from 'react-router-dom';
import * as z from 'zod';

import { useAuthContext } from '../../providers/AuthContextProvider';
import { SingleCenterCard } from '../SingleCenterCard';

const schema = z.object({
  email: z.string().email().min(2),
  password: z.string().min(6)
});

export function SignUp() {
  const [error, setError] = useState<string>('');
  const { signUp, loading } = useAuthContext();

  const {
    handleSubmit,
    register,
    formState: { errors }
  } = useForm<z.infer<typeof schema>>({
    resolver: zodResolver(schema)
  });

  const onSubmit: SubmitHandler<z.infer<typeof schema>> = useCallback(
    (data) => {
      signUp(data.email, data.password).catch((e) => {
        setError(String(e));
      });
    },
    [signUp]
  );

  return (
    <SingleCenterCard header={'Sign Up'}>
      {error && <Alert status={'error'}>{error}</Alert>}

      <form onSubmit={handleSubmit(onSubmit)}>
        <FormControl isInvalid={!!errors.email} mb={'1rem'}>
          <FormLabel>Email address</FormLabel>
          <Input {...register('email')} type={'email'} />
          {errors.email?.message && <FormErrorMessage>{errors.email?.message}</FormErrorMessage>}
        </FormControl>

        <FormControl isInvalid={!!errors.password} mb={'1rem'}>
          <FormLabel>Password</FormLabel>
          <Input {...register('password')} type={'password'} />
          {errors.password?.message && (
            <FormErrorMessage>{errors.password?.message}</FormErrorMessage>
          )}
        </FormControl>

        <Button
          isLoading={loading}
          mb={'1rem'}
          w={'100%'}
          type={'submit'}
          value={'login'}
          variant={'solid'}
        >
          SignUp
        </Button>

        <Divider mb={'1rem'} />

        <Center>
          <Text mr={1}>Already have an account?</Text>
          <Link as={ReactRouterLink} to={`/login${window.location.search}`}>
            Login
          </Link>
        </Center>
      </form>
    </SingleCenterCard>
  );
}

export default SignUp;
